var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCargo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.5C1.95 19.5 1.47917 19.3042 1.0875 18.9125C0.695833 18.5208 0.5 18.05 0.5 17.5V6.5C0.5 5.95 0.695833 5.47917 1.0875 5.0875C1.47917 4.69583 1.95 4.5 2.5 4.5H6.5V2.5C6.5 1.95 6.69583 1.47917 7.0875 1.0875C7.47917 0.695833 7.95 0.5 8.5 0.5H12.5C13.05 0.5 13.5208 0.695833 13.9125 1.0875C14.3042 1.47917 14.5 1.95 14.5 2.5V4.5H18.5C19.05 4.5 19.5208 4.69583 19.9125 5.0875C20.3042 5.47917 20.5 5.95 20.5 6.5V17.5C20.5 18.05 20.3042 18.5208 19.9125 18.9125C19.5208 19.3042 19.05 19.5 18.5 19.5H2.5ZM2.5 17.5H18.5V6.5H2.5V17.5ZM8.5 4.5H12.5V2.5H8.5V4.5Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/cargo.8729933f325a8cc27135e4e3efce4311.svg";
export { ForwardRef as ReactComponent };